import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'

import CheckboxInner from './CheckboxInner'

/**
 * Component of Checkbox input<br />
 * <br />
 * Note: <small>Indeed it's wrapper around CheckboxInner component to use it with final-form library.
 * So it would work only inside Final Form's wrapper component.
 * </small>
 * @return {component} svg element
 */
const Checkbox = ({ name, ...remainingProps }) => {
  return (
    <Field
      {...remainingProps}
      type="checkbox"
      name={name}
      component={CheckboxInner}
    />
  )
}

Checkbox.propTypes = {
  /** Name of field */
  name: PropTypes.string.isRequired,

  /** Label for checkbox */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /** Function to implement rules. It has to return error message. You may read about it in Introduction article */
  validate: PropTypes.func,

  /** Is checkbox disabled */
  isDisabled: PropTypes.bool,
}

export default Checkbox
